import React from 'react';

export const CameraContext = React.createContext({
  cameraX: 0,
  cameraY: 0,
  cameraScale: 1,
  worldToScreen: () => ({ screenX: 0, screenY: 0 }),
  screenToWorld: () => ({ x: 0, y: 0 })
});
